import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Table, TableBody, TableContainer, TableHead, TableRow, IconButton, Tooltip, Paper, TablePagination, Box, CircularProgress } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";
import { disableLab } from "../../../services/mentorServices/MentorServices";
import { toast } from "react-toastify";
import ConfirmDisableModal from "../../ConfirmDisableModal";
import StudentListModal from "../../adminComponents/COE/StudentListModal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#7e7e7e",
    color: theme.palette.common.white,
    textTransform: "capitalize",
    fontSize: 16,
    fontWeight: 600
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textTransform: "capitalize",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme, disabled }) => ({
  "&:nth-of-type(odd),&:nth-of-type(even)": {
    backgroundColor: disabled ? theme.palette.action.disabledBackground : theme.palette.action.hover,
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const LabPracticeTable = ({ rowData, handleEditClick, getAllLabsData, loadingData, setLoadingData }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [openModal, setOpenModal] = useState(false);
  const [selectedLab, setSelectedLab] = useState(null);
  const [isStudentModalOpen, setIsStudentModalOpen] = useState(false);
  const [selectedStudentRow, setSelectedStudentRow] = useState(null);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = (lab) => {
    setSelectedLab(lab);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedLab(null);
  };

  const handleOpenStudentModal = (row) => {
    setSelectedStudentRow(row);
    setIsStudentModalOpen(true);
  };

  const handleCloseStudentModal = () => {
    setIsStudentModalOpen(false);
    setSelectedStudentRow(null);
  };

  const handleConfirmDisable = async () => {
    if (!selectedLab) return;
    try {
      const response = await disableLab(selectedLab.id);
      toast.success(response?.data.message);
      getAllLabsData();
    } catch (error) {
      toast.error(error?.response?.data.message || error?.message || error?.error);
    } finally {
      handleCloseModal();
    }
  };

  const paginatedRows = rowData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
        <TableContainer component={Paper} className="table-container" sx={{ width: "100%", overflowX: "auto" }}>
        <Table sx={{ tableLayout: "auto", width: "max-content", minWidth:"100%" }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>COE</StyledTableCell>
              <StyledTableCell>Lab Name</StyledTableCell>
              <StyledTableCell>Practice Time</StyledTableCell>
              <StyledTableCell>Lab Type</StyledTableCell>
              <StyledTableCell>Learners#</StyledTableCell>
              {/* <StyledTableCell>Actions</StyledTableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingData ? (
              <TableRow>
                <StyledTableCell colSpan={5} align="center">
                  <Box display="flex" justifyContent="center" alignItems="center" height="30px">
                    <CircularProgress />
                  </Box>
                </StyledTableCell>
              </TableRow>
            ) :

              paginatedRows?.sort((a, b) => new Date(b?.create_date) - new Date(a?.create_date))?.map((row, index) => (
                <StyledTableRow key={index} disabled={row.disabled}>
                  <StyledTableCell>{row.base_coe?.name || "-"}</StyledTableCell>
                  <StyledTableCell>{row.lab_name || "-"}</StyledTableCell>
                  <StyledTableCell>{row.startTime} - {row.endTime || "-"}</StyledTableCell>
                  <StyledTableCell>{row.lab_type || "-"}</StyledTableCell>
                  <StyledTableCell
                    onClick={() => handleOpenStudentModal(row)}
                    style={{ cursor: "pointer", color: "blue" }}
                  >
                    {row.learnerCount ?? row.learnersCount ?? row.learners_count ?? row.learner_count ?? row.base_coe?.learnerCount ?? row.base_coe?.learnersCount ?? (Array.isArray(row.learners) ? row.learners.length : 0)}
                  </StyledTableCell>
                  {/* <StyledTableCell>
                    <Tooltip title="Edit" arrow>
                      <IconButton size="small" aria-label="edit" onClick={() => handleEditClick(row)}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Disable" arrow>
                      <IconButton
                        size="small"
                        aria-label="disable"
                        onClick={() => handleOpenModal(row)}
                        disabled={row.disabled}
                      >
                        <BlockIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </StyledTableCell> */}
                </StyledTableRow>
              ))
            }
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10,20,30,60,100]}
          component="div"
          count={rowData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>

      <ConfirmDisableModal
        open={openModal}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDisable}
        message={`lab "${selectedLab?.lab_name}"`}
      />

      <StudentListModal
        open={isStudentModalOpen}
        onClose={handleCloseStudentModal}
        studentData={selectedStudentRow}
        fetchCoeData={getAllLabsData}
        isMentorView={true}
      />
    </>
  );
};

export default LabPracticeTable;
